import React from "react";
import "./OverView.scss";

function OverView() {
  return (
    <div className="Overview">
      <div className="Overview__activeContainer">
        <p className="title">Active Plan</p>
        <div className="card">
          <div className="card__content">
            <ul>
              <li>Basic Plan (Free)</li>
              <li>Effective Till 10th December</li>
              <li>Total Storage 1GB</li>
              <li>Total Bandwidth 1GB</li>
            </ul>
          </div>

          <div className="card__buttonBox">
            <button className="outlineBtn">Change Plan</button>
          </div>
        </div>
      </div>

      <div className="Overview__recentTransactionsContainer">
        <p className="title">Recent Transaction</p>
        <div className="card">ss</div>
      </div>
    </div>
  );
}

export default OverView;
